var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"width":"600","title":"批量操作结果","mask-closable":false,"class-name":"vertical-center-modal"},on:{"on-ok":function($event){return _vm.$emit('on-ok')}},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('Table',{attrs:{"height":"300","columns":_vm.columns,"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }